module.exports = __webpack_public_path__ + "img/play_your_way_graphic.ca975326.png";